import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ChatBotService {
  api_url = environment.SERVER_URL + 'icrweb/home/'
  constructor(
    private http: HttpClient,
  ) { }
  getMessages(request) {
    return this.http.post(this.api_url + "get_onboarding_manager_form_notes", request, {
      headers: {
        header_type: '2'
      }
    });
  }
  sendMessage(request) {
    return this.http.post(this.api_url + "save_onboarding_manager_form_notes", request, {
      headers: {
        header_type: '2'
      }
    });
  }
}
